<template>
	<div>
		<el-row style=" margin: 0px auto 5px;background: white;padding: 10px 20px 5px;">
			<el-col :span="12">
				<el-upload
					class="upload-demo"
					ref="upload"
					:action="uploadurl"
					:on-preview="handlePreview"
					:on-remove="handleRemove"
					:on-change="handleChange"
					:on-success="handleSuccess"
					:on-error="handleError"
					:file-list="fileList"
					:limit="1"
				>
					<el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6422]')}}</el-button>
					<div slot="tip" class="el-upload__tip">{{$t('getapi[6484]')}}</div>
				</el-upload>
			</el-col>
			<el-col :span="12" align="right">
				<span class="label-fade-enter">{{$t('getapi[506]')}}</span>
				<el-select filterable v-model="drosele" size="mini">
					<el-option v-for="item in drolist" :label="item.TypeName" :value="item.TypeId" :key="item.TypeId"></el-option>
				</el-select>
				<el-button @click="okbtn" size="mini" type="success" :loading="loading" :disabled="loading">{{$t('getapi[507]')}}</el-button>
			</el-col>
		</el-row>

		<!-- 表格 -->
		<div id="xpane-0">
			<vxe-table
			:data="datajson"
			v-loading="loading"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			tab-click="selectInfo(0)"
			header-row-class-name="headerclass"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			:header-cell-style="$limits.headerClass"
			ref="singleTable"
		>
			<vxe-table-column show-overflow-tooltip field="Exclusively_ID" title="ID" v-if="false" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="datastatus" :title="$t('getapi[504]')" width="130px" class="check"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="customer_order" :title="$t('getapi[1596]')" width="100px"></vxe-table-column>
			<vxe-table-column :class-name="drosele == 1 ? 'check' : ''" field="commit_delivery_date" :title="$t('getapi[2704]')" width="130px">
				<template slot-scope="scope">
					<el-input v-model="scope.row.commit_delivery_date" type="text" :disabled="drosele != 1"></el-input>
				</template>
			</vxe-table-column>
		<!-- 	<vxe-table-column show-overflow-tooltip field="commit_delivery_date" :title="$t('getapi[2704]')" width="100px"></vxe-table-column> -->
			<vxe-table-column show-overflow-tooltip field="customer_id" :title="$t('getapi[2692]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="customer_name" :title="$t('getapi[2584]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="status" :title="$t('getapi[552]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="line_no" :title="$t('getapi[1425]')" width="100px" align="right"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="sales_part" :title="$t('getapi[2652]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="part_name" :title="$t('getapi[2653]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[2654]')" width="100px"></vxe-table-column>
			<!-- <vxe-table-column show-overflow-tooltip field="version_status" :title="$t('getapi[552]')" width="100px"></vxe-table-column> -->
			
			<vxe-table-column show-overflow-tooltip field="spec" :title="$t('getapi[4187]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="model" :title="$t('getapi[124]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="cuspart_id" :title="$t('getapi[2390]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="cuspart_name" :title="$t('getapi[2391]')" width="100px"></vxe-table-column>
			<vxe-table-column field="sales_qty" :title="$t('getapi[3602]')" width="100px" align="right">
				<template slot-scope="scope">
					{{scope.row.sales_qty | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="co_line_sn_qty" :title="$t('getapi[2702]')" width="100px" align="right">
				<template slot-scope="scope">
					{{scope.row.co_line_sn_qty | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="co_line_rma_qty" :title="$t('getapi[2703]')" width="100px" align="right">
				<template slot-scope="scope">
					{{scope.row.co_line_rma_qty | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="sales_unit" :title="$t('getapi[3100]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="currency_code_id" :title="$t('getapi[1338]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="package" :title="$t('getapi[3417]')" width="100px"></vxe-table-column>
			<vxe-table-column :class-name="drosele == 2 ? 'check' : ''" field="plan_delivery_date" :title="$t('getapi[2694]')" width="130px">
				<template slot-scope="scope">
					<el-input v-model="scope.row.plan_delivery_date" type="text" :disabled="drosele != 2"></el-input>
				</template>
			</vxe-table-column>
			<!-- <vxe-table-column show-overflow-tooltip field="plan_delivery_date" :title="$t('getapi[2694]')" width="100px"></vxe-table-column> -->
			<vxe-table-column show-overflow-tooltip field="commit_delivery_date" :title="$t('getapi[2705]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[2706]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="consignment_flag" :title="$t('getapi[2285]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="direct_move_flag" :title="$t('getapi[2592]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="moving_pos" :title="$t('getapi[2593]')" width="100px"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="package" :title="$t('getapi[2707]')" width="100px"></vxe-table-column>
			
			
			<vxe-table-column fixed="right" :title="$t('getapi[6048]')" width="120">
				<template slot-scope="scope">
					<el-popconfirm
						:confirmButtonText="$t('getapi[1146]')"
						:cancelButtonText="$t('getapi[6]')"
						icon="el-icon-info"
						iconColor="red"
						:title="$t('getapi[637]')"
						@onConfirm="delline(scope)"
					>
						<el-button slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
						<!-- <el-button slot="reference" type="text" size="small"></el-button> -->
					</el-popconfirm>
				</template>
			</vxe-table-column>
		</vxe-table>
		</div>
	</div>
</template>

<script>
import Common from '@/components/Common';
export default {
	name: 'salorderchange',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight-180
        }
    },
	data() {
		return {
			fileList: [],
			ids: '',
			showloading: '',
			DbTbNames: '', //表名
			datajson: [],
			datajsonremark: [],
			datajsonliu: [],
			loading: false, // 主表加载状态
			uploadurl: '',
			uploadurlremark: '',
			uploadurlliu: '',
			drolist: [],
			drolistliu: [],
			drosele: 0,
			droseleliu: 0,
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		let token = JSON.parse(that.userData).token;
		that.uploadurl = Common.Url + 'Sal/Order/SalBatchUpdateFile?token=' + token;
		console.log(that.uploadurl);
		this.getDropList();
	},
	mounted() {
		console.log('mounted');
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		//删除行
		delline(e) {
			let line = e.$index;
			if (line >= 0) {
				this.datajson.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},
		

		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
			console.log(that.selectIDData);
		},
		//更新字段下拉框
		getDropList() {
			let that = this;
			that.$http.urlpost('/Sal/Order/SalBatchUpdateDropList', {}, res => {
				console.log(res);
				if (res.Success == 1) {
					that.drolist = res.DataContent;
				}
			});
		},
		
		handleChange(file, fileList) {
			let that = this;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					that.datajson = file.response.DataContent;
				}
			}
		},
		handleSuccess(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
                that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				that.datajson = res.DataContent;
			}
			that.fileList=[];
		},
		handleError(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
			that.fileList=[];
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			console.log(file);
		},
		// 保存数据
		okbtn() {
			let that = this;
			that.loading = true;
			let parm = {
				SaveType: that.drosele,
				List: [],
				LangType: that.$processdata.getLang(),
			};
			parm.List = that.datajson;
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Sal/Order/SalBatchUpdateSave', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
span.label-fade-enter {
	font-size: medium;
	margin-right: 20px;
}
</style>
